import { useQuery } from "@tanstack/react-query";

import { PublicInformation } from "helpers/queriesDataKeys";
import {
  API_BASE_URL,
  LIVE_SITE,
  LIVE_VENDOR_SITE,
  TEST_SITE,
  TEST_VENDOR_SITE,
} from "configs/AppConfig";

import NavList from "./NavList";

import classes from "./Footer.module.css";
import { useLocation, useNavigate } from "react-router";
import { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Scrollbars from "react-custom-scrollbars";
import useWindowWidth from "helpers/useWindowWidth";
import { NavigationContext } from "App";

const FaqList = [{ name: "FAQ", to: "/faq" }];
const ConnectNavList = [{ name: "Contact Us", to: "/contact-us" }];

const Footer = () => {
  const user = useSelector((state) => state.user);
  const width = useWindowWidth();
  const { settings } = useSelector((state) => state.settings);
  const navigate = useNavigate();
  const { homeApis } = useSelector((state) => state.widgets); // Access widget data

  const sessionStore = "home";
  const { setIsBackNavigation } = useContext(NavigationContext);

  const storePosition = () => {
    const yPos = window.scrollY;
    sessionStorage.setItem("scrollTargetY", yPos.toString());
    sessionStorage.setItem("scrollOrigin", sessionStore); // or "branch" depending on the page
    setIsBackNavigation(true);
  };

  const socialIcons = [
    { image: "/img/icons/fb-footer.svg", url: settings?.facebookLink },
    { image: "/img/icons/ig-footer.svg", url: settings?.instagramLink },
    { image: "/img/icons/x-footer.svg", url: settings?.twitterLink },
    { image: "/img/icons/p-footer.svg", url: settings?.pinterestLink },
    { image: "/img/icons/yt-footer.svg", url: settings?.youtube },
    { image: "/img/icons/td-footer.svg", url: settings?.threadLink },
  ];

  // const fetchInformations = async () => {
  //   const response = await fetch(
  //     `${API_BASE_URL}Pages/getAll?categorySlug=informations&sortByPriority=true`,
  //     {
  //       method: "GET",
  //       headers: {
  //         "Content-Type": "application/json",
  //         // Authorization: `Bearer ${user.sessionToken}`,
  //       },
  //       // body: JSON.stringify(),
  //     }
  //   );

  //   const data = await response.json();
  //   setInformationsData(
  //     data.data.map((item) => ({ label: item.name, value: item.slug }))
  //   );
  //   console.log("response", data);
  //   if (!response.ok) {
  //     // message.error(data.message ? data.message : "Invalid Email or Password");
  //     throw new Error(data.message);
  //   }

  //   return data;
  // };

  // const fetchEvents = async () => {
  //   const response = await fetch(`${API_BASE_URL}eventType/get/all`, {
  //     method: "GET",
  //     headers: {
  //       "Content-Type": "application/json",
  //       // Authorization: `Bearer ${user.sessionToken}`,
  //     },
  //     // body: JSON.stringify(),
  //   });

  //   const data = await response.json();
  //   setEventData(data.data);
  //   console.log("response", data);
  //   if (!response.ok) {
  //     // message.error(data.message ? data.message : "Invalid Email or Password");
  //     throw new Error(data.message);
  //   }

  //   return data;
  // };

  // const fetchPolicy = async () => {
  //   const response = await fetch(
  //     `${API_BASE_URL}information-policy/getAll/public`,
  //     {
  //       method: "GET",
  //       headers: {
  //         "Content-Type": "application/json",
  //         // Authorization: `Bearer ${'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6IldFRDQ3OTg3IiwiaWF0IjoxNzI4MDQ1OTEyLCJleHAiOjE3MzMyMjk5MTJ9.3HysYfkVWSiALnQUGBTH4ag6J0CwHExqJJGBkWIU5sE'}`,
  //       },
  //       // body: JSON.stringify(),
  //     }
  //   );

  //   const data = await response.json();
  //   setPolicyData(data.data?.sort((a, b) => a.priority - b.priority));
  //   console.log("response", data);
  //   if (!response.ok) {
  //     // message.error(data.message ? data.message : "Invalid Email or Password");
  //     throw new Error(data.message);
  //   }

  //   return data;
  // };

  // useEffect(() => {
  //   fetchInformations();
  //   // fetchEvents();
  //   fetchPolicy();
  // }, [user]);

  const location = useLocation();
  const isCart = location.pathname.includes("cart");
  console.log("isCart", location.pathname.includes("cart"));
  const isCheckout = location.pathname.includes("checkout");

  return (
    <>
      {!(isCart || isCheckout) && (
        <div className={classes.footer}>
          <div className={classes.footerContent}>
            <div className={classes.footerLeft}>
              <Link to="/">
                {/* <div className={classes.siteIcon}></div> */}
                <img
                  src="/img/logo-footer.svg"
                  alt="Logo"
                  loading="lazy"
                  className={classes.siteIcon}
                />
              </Link>
              <p>
                The Next - Gen Event Marketplace to Discover and Book everything
                you need for your Special Event
              </p>
              <h2 className={classes.bestDeal}>Get Best Deal</h2>
              <div className={classes.vendorAndCustomer}>
                <div className={classes.vendorSection}>
                  <p>Vendor</p>
                  <div
                    className={classes.vendorWhatsapp}
                    onClick={() =>
                      window.open(
                        `https://wa.me/${settings?.phoneNumber}`,
                        "_blank"
                      )
                    }
                  >
                    <img src="/img/icons/whatsapp-white.svg" />
                    <h2>{settings?.phoneNumber}</h2>
                  </div>
                </div>

                <div className={classes.customerSection}>
                  <p>Customer</p>
                  <div
                    onClick={() =>
                      window.open(
                        `https://wa.me/${settings?.customerContactNo}`,
                        "_blank"
                      )
                    }
                    className={classes.customerWhatsapp}
                  >
                    <img src="/img/icons/whatsapp-white.svg" />
                    <h2>{settings?.customerContactNo}</h2>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className={classes.footerRight}> */}
            <div className={classes.footerItems}>
              <h3>Informations</h3>

              {homeApis?.pages?.map((item) => (
                <p
                  onClick={() => {
                    storePosition();
                    navigate(`/${item?.slug}`);
                  }}
                >
                  {item?.name}
                </p>
              ))}
            </div>
            {/* <div className={`${classes.footerItems} ${classes.footerPolicy}`}>
                <h3>Policy</h3>
                <Scrollbars
                  style={{ width: "100%", height: width > 767 ? 202 : 120 }}
                  //autoHide // This prop hides the scrollbar when not scrolling
                >
                {policyData?.map((item) => (
                  <Link to={`/information-policy/${item.slug}`}>
                    <p className={classes.scrollBarItem}>{item.data.title}</p>
                  </Link>
                ))}
                </Scrollbars>
              </div> */}
            <div className={`${classes.footerItems} ${classes.footerPolicy}`}>
              <h3>Policy</h3>
              <div
                className={classes.scrollContainer}
                style={{
                  maxHeight: width > 767 ? 202 : 120,
                  overflowY: "auto",
                }}
              >
                {homeApis?.informationPolicies?.map((item) => (
                  <p
                    onClick={() => {
                      storePosition();
                      navigate(`/information-policy/${item?.slug}`);
                    }}
                    className={classes.scrollBarItem}
                  >
                    {item?.data?.title}
                  </p>
                ))}
              </div>
            </div>

            {/* <div className={classes.footerItems}>
                <h3>Connect With Us</h3>
                <p>Facebook</p>
                <p>Twitter</p>
                <p>Instagram</p>
              </div> */}
            {/* <div
                className={`${classes.footerItems} ${classes.additionalClass}`}
              >
                <h3>Information Policy</h3>
                <Scrollbars
                  style={{ width: "100%", height: width > 767 ? 130 : 115 }}
                  autoHide // This prop hides the scrollbar when not scrolling
                >
                  {policyData?.map((item) => (
                    <Link to={`/information-policy/${item.slug}`}>
                      <p className={classes.scrollBarItem}>{item.data.title}</p>
                    </Link>
                  ))}
                </Scrollbars>
              </div> */}
            <div className={`${classes.footerItems} ${classes.playButton}`}>
              <button
                onClick={() => {
                  const url =
                    process.env.REACT_APP_API_STAGE == "Dev"
                      ? TEST_VENDOR_SITE
                      : LIVE_VENDOR_SITE;
                  if (url) {
                    window.open(url, "_blank");
                  }
                }}
                className={classes.vendorButton}
              >
                Register as a Vendor
              </button>
              <h3> Get The Vendor app</h3>

              <div className={classes.downloadOptions}>
                <div
                  className={classes.appStore}
                  onClick={() =>
                    window.open(
                      "https://apps.apple.com/in/app/eventoq/id6737259444",
                      "_blank"
                    )
                  }
                >
                  <img src="/img/icons/app-store-icon.svg" />
                  <div>
                    <p>Download on the</p>
                    <h2>App Store</h2>
                  </div>
                </div>
                <div
                  className={classes.playStore}
                  onClick={() =>
                    window.open(
                      "https://play.google.com/store/apps/details?id=com.eventoq&hl=en_IN",
                      "_blank"
                    )
                  }
                >
                  <img src="/img/icons/play-store-icon.svg" />
                  <div>
                    <p>Get it On</p>
                    <h2>Google Play</h2>
                  </div>
                </div>
              </div>
              <h2 className={classes.followUs}>Follow Us</h2>
              <div className={classes.socialIcons}>
                {socialIcons
                  ?.filter((data) => data?.url)
                  ?.map((item) => (
                    <img
                      onClick={() => {
                        storePosition();
                        window.open(item?.url, "_blank");
                      }}
                      src={item?.image}
                      className={classes.socialImage}
                    />
                  ))}
              </div>
            </div>
            {/* </div> */}
          </div>
        </div>
      )}
      <div className={classes.footerBottom}>
        <img
          src="/img/icons/wittywrap-icon.svg"
          className={classes.weddingIcon}
        />
        <p>
          EVENTOQ © {new Date().getFullYear()} v1.3.6. All rights reserved
          {/* | Developed By{" "}
          <span
            style={{ cursor: "pointer" }}
            onClick={() => window.open("https://riolabz.com/", "_blank")}
          >
            Riolabz
          </span>
          . All rights reserved. */}
        </p>
        <div>
          <span className={classes.poweredBy}>Powered by</span>&nbsp;&nbsp;
          <span
            className={classes.poweredByTwo}
            style={{ cursor: "pointer" }}
            onClick={() => window.open("https://www.riolabz.com/", "_blank")}
          >
            riolabz.com
          </span>
        </div>
      </div>
    </>
  );
};

export default Footer;
